"use client";

import { trackFaireDirectFaireDirectLandingPageSignUpClick } from "@faire/web-api/events/faireDirect/click/faireDirectLandingPageSignUp";
import { IFilterOption } from "@faire/web-api/indigofair/data/IFilterOption";
import { History } from "history";
import React from "react";

import {
  usePopSignUp,
  SignUpElement,
  SignUpType,
} from "@faire/retailer/lib/popSignUp";

import { useLoggedOutProductFilters } from "../brand-products/useLoggedOutProductFilters";

import { FilterTabsBase } from "./FilterTabsBase";

export const FaireDirectFilterTabs: React.FC<{
  brandToken: string | undefined;
  categoryFilterOptions: Array<IFilterOption> | null;
  locationPush: (location: History.LocationDescriptor) => void;
}> = ({ brandToken, categoryFilterOptions, locationPush }) => {
  const { activeTab } = useLoggedOutProductFilters(locationPush);
  const { popSignUp } = usePopSignUp();
  const handleFilterSelected = () => {
    popSignUp(
      SignUpType.FAIRE_DIRECT,
      () => {
        trackFaireDirectFaireDirectLandingPageSignUpClick("C2_CLICK");
      },
      {
        element: SignUpElement.PRODUCT_GRID,
        sourceId: "brand_summary_products_c2",
      },
      {
        brand: brandToken,
      }
    );
  };

  return (
    <FilterTabsBase
      activeTab={activeTab}
      onTabChange={(key) => {
        if (key === activeTab) {
          return;
        }
        handleFilterSelected();
      }}
      categoryFilterOptions={categoryFilterOptions}
    />
  );
};
